import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { BaseModule } from '../../libraries/base/base.module';
import { LibrariesModule } from '../../libraries/libraries.module';
import { SharedModule } from '../../libraries/shared.module';
import { DashboardDealerCreditNoteComponent } from './dashboard-dealer/dashboard-dealer-credit-note.component';
import { DashboardDealerRestService } from './dashboard-dealer/dashboard-dealer-rest.service';
import { DashboardDealerComponent } from './dashboard-dealer/dashboard-dealer.component';
import { DashboardRestService } from './dashboard-rest.service';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { DashboardListComponent } from './list/dashboard-list.component';
import { BasePageComponent } from '../../libraries/base/page/base-page.component';
import { TransactionHistoryComponent } from './transaction-history/transaction-history.component';
import { ChipComponent } from './components/chip/chip.component';
import { TransactionCardComponent } from './components/transaction-card/transaction-card.component';
import { FormsModule } from '@angular/forms';
import { GridTableColumnComponent } from '../../libraries/grid-table/column/grid-table-column.component';
import { GridTableColumnModule } from '../../libraries/grid-table/column/grid-table-column.module';
import { TransactionHistoryTableComponent } from './transaction-history-table/transaction-history-table.component';
import { TopUpComponent } from './top-up-modal/top-up.component';
import { ModalComponent } from './components/modal/modal.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { WithdrawComponent } from './withdraw-modal/withdraw.component';
import { WithdrawApprovalTableComponent } from './withdraw-approval-table/withdraw-approval-table.component';
import { WithdrawDetailComponent } from './withdraw-detail/withdraw-detail.component';
import { MembershipInvoiceModal } from './membership-invoice-modal/membership-invoice-modal.component';
import { ImgUploadV2Module } from '../../libraries/img-upload-v2/img-upload-v2.module';

export const PROVIDERS = [DashboardRestService, DashboardDealerRestService, BasePageComponent];
@NgModule({
  imports: [
    CommonModule,
    BaseModule,
    DashboardRoutingModule,
    LibrariesModule,
    SharedModule,
    TranslateModule,
    TableModule,
    DialogModule,
    ButtonModule,
    FormsModule,
    ImgUploadV2Module
  ],
  declarations: [
    ModalComponent,
    DashboardComponent,
    DashboardListComponent,
    DashboardDealerComponent,
    DashboardDealerCreditNoteComponent,
    TransactionHistoryComponent,
    ChipComponent,
    TransactionCardComponent,
    TransactionHistoryTableComponent,
    TopUpComponent,
    WithdrawComponent,
    WithdrawApprovalTableComponent,
    WithdrawDetailComponent,
    MembershipInvoiceModal,

  ]
})
export class DashboardModule {}
